import { GymImage } from './gymImage';
import { NetworkType } from './gym';

export enum ChangeSource {
  PARTNER_PORTAL = 'PARTNER_PORTAL',
  INTERNAL_ADMIN = 'INTERNAL_ADMIN',
}

export enum ChangeReviewStatus {
  VIEWED = 'VIEWED',
  NOT_VIEWED = 'NOT_VIEWED',
  NO_REVIEW_REQUIRED = 'NO_REVIEW_REQUIRED',
}

export class ChangeLogMetadata {
  field: string;
  oldValue: any;
  newValue: any;

  formattedField: string;
}

export class ChangeLog {
  id: string;
  gymId: string;
  gymName: string;
  metadata: ChangeLogMetadata[];
  createdAt: number;
  modifiedBy: string;
  reviewStatus: ChangeReviewStatus;
  source: ChangeSource;
  network?: NetworkType;
  formattedFields: string;
  formattedCreatedAt: string;
  formattedSource: string;
  formattedReviewStatus: string;
  formattedNetwork: string;
}

export type GymChangeLogResponse = {
  nextToken?: string;
  gymChangeLogs: ChangeLog[];
};

export type ChangeLogFilter = {
  egymGymId?: string;
  source?: string;
  reviewStatus?: string;
  network?: string[];
  networkNotSet?: boolean;
  fieldType?: string[];
};

export type ChangeLogFilterAndPagination = ChangeLogFilter & {
  nextToken?: string;
  limit?: number;
};

export type GymImagesMetadata = {
  images: GymImage[];
  deletedImages: GymImage[];
};

export const FIELD_TYPE_OPTIONS: { value: string; display: string }[] = [
  { value: 'accessDescription', display: 'Access description' },
  { value: 'activities', display: 'Activities' },
  { value: 'description', display: 'Description' },
  { value: 'email', display: 'Email' },
  { value: 'equipmentsToBring', display: 'Equipment to bring' },
  { value: 'externalBookingInfo', display: 'External booking info' },
  { value: 'gymEquipments', display: 'Gym equipment' },
  { value: 'gymImages', display: 'Gym images' },
  { value: 'gymInfos', display: 'Gym infos' },
  { value: 'instagram', display: 'Instagram' },
  { value: 'openingHoursV2', display: 'Opening hours' },
  { value: 'phone', display: 'Phone' },
  { value: 'services', display: 'Services' },
  { value: 'website', display: 'Website' },
];
